export default "__VITE_ASSET__BvuWQIfs__"